/**
 * Anzeigenamen, die mehr als eine Ansicht braucht — Panel, Ausdruck und die
 * technische Beschreibung sollen dieselben Worte verwenden.
 */

import type { Komponentenart, Verlegeart } from './typen.ts';

export const ARTNAMEN: Record<Komponentenart, string> = {
  wechselrichter: 'Wechselrichter',
  speicher: 'Speicher',
  wallbox: 'Wallbox',
  heizstab: 'Heizstab',
  ueberspannungsschutz: 'Überspannungsschutz',
  smartmeter: 'Smart-Meter',
  notstrom: 'Netz-Not-Umschaltung',
  wlv_zk: 'WLV im Zählerkasten',
  wlv_extern: 'WLV extern',
  internet: 'Internetanschluss',
  sicherungstrennschalter: 'Sicherungstrennschalter',
  fi_ls: 'FI/LS am Wechselrichter',
  zaehlersteckleiste: 'Zählersteckleiste',
  sonstiges: 'Sonstiges',
};

export const VERLEGEARTEN: Array<[Verlegeart, string]> = [
  ['standard', 'Ohne Rohr'],
  ['rohr_alu', 'Alurohr'],
  ['rohr_edelstahl', 'Edelstahlrohr'],
  ['geschirmt', 'Geschirmtes Kabel'],
  ['erdkabel', 'Erdkabel'],
];
